// src/utils/roles.js
export const ROLES = ["superadmin", "admin", "coach", "member"];

const ROLE_KEY = "nia_role";
const PROFILE_KEY = "nia_profile"; // { firstName, lastName, username, email, country, province, city, photoURL }

export function getCurrentRole() {
  const r = localStorage.getItem(ROLE_KEY);
  return ROLES.includes(r) ? r : "superadmin";
}

export function setCurrentRole(role) {
  const val = ROLES.includes(role) ? role : "member";
  localStorage.setItem(ROLE_KEY, val);
  window.dispatchEvent(new Event("nia-role-changed"));
}

export function getProfile() {
  try {
    const raw = localStorage.getItem(PROFILE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

export function saveProfile(next) {
  const prev = getProfile();
  localStorage.setItem(PROFILE_KEY, JSON.stringify({ ...prev, ...next }));
  window.dispatchEvent(new Event("nia-profile-changed"));
}

export function getProfilePhoto() {
  const p = getProfile();
  return p.photoURL || "";
}

export function resolvePersistedUserPhoto(...sources) {
  for (const source of [...sources, getProfile()]) {
    const photoURL = source && typeof source === "object"
      ? String(source.photoURL || "").trim()
      : String(source || "").trim();
    if (photoURL) return photoURL;
  }
  return "";
}

export function resolveUserPhoto(...sources) {
  for (const source of sources) {
    const direct = String(source || "").trim();
    if (direct) return direct;
    if (source && typeof source === "object") {
      const photoURL = String(source.photoURL || "").trim();
      if (photoURL) return photoURL;
      const photoDataUrl = String(source.photoDataUrl || "").trim();
      if (photoDataUrl) return photoDataUrl;
    }
  }
  return "";
}
